<div class="rask-card">
    <rask-container-block>
        @if (renderRaskheader) {
        <div class="rask-card-header">
            <rask-header [attr.size]="size" noPadding>
                @if (isLink) {
                @if(showHeaderIcon) {
                <i class="{{headerIcon}} header-icon"></i>
                }
                <a [href]="href" target="_blank">{{label}}</a>
                }
                @if (!isLink) {
                @if(showHeaderIcon) {
                <i class="{{headerIcon}} header-icon"></i>
                }

                <span>{{label}}</span>
                }
                @if (showHeader) {
                <div class="rask-card-header-content">
                    <rask-icon [icon]="iconClass" [ngClass]="{'disabled': headerIconDisabled}"
                        (click)="clicked()"></rask-icon>
                </div>
                }
            </rask-header>
        </div>
        }
        <div class="rask-card-body">
            <ng-content></ng-content>
        </div>
    </rask-container-block>
</div>